export default "__VITE_ASSET__30ea7c0a__"